<template>
  <!--=== banner ==========-->
  <div v-if="bannerTopo.length > 0" class="top-banner-area topo-cel">
    <div class="top-banner-content">

      <img
        class="top-banner-image"
        :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem"
        :alt="bannerTopo[0].itiNome"
      />

      <div class="top-banner-overlay">
        <div class="container">
          <div class="row align-items-center h-100">
            <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12">
              <div class="hero-caption hero-caption2">
                <h2>{{ bannerTopo[0].itiNome }}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!--  final banner -->

  <!--=== produtos ==========-->
  <div class="services-area1 section-padding">
    <div class="container">

      <div class="row">

        <!-- menu -->
        <div v-if="segmentospais.length > 0" class="col-lg-3 mb-60">
          <div class="produtos-menu menu-lateral">
            <ul :class="{ aberto: menuAberto }" class="produtos-menu__list">
              <li v-for="menu in segmentospais" :key="menu.sgiId" class="produtos-menu__item">
                <a @click.prevent="filtraProdutos(menu.sgiId)" href="#"
                  :class="{ active: menu.sgiId === segmentoSelecionado }">{{ menu.sgiNomeSegmento }}</a>
              </li>
            </ul>
          </div>
        </div>

        <!-- produtos -->
        <div v-if="ListaProdutosSegmento.length > 0" class="col-lg-9">
          <div>
            <h2 id="produtos-titulo-selecionado" class="text-center produtos-titulo">
              {{ tituloCategorias }} </h2>
          </div>
          <div class="row">
            <div class="col-lg-4" v-for="(produto) in ListaProdutosSegmento" :key="produto.itiId">
              <!-- Single -->
              <div class="properties pb-30">
                <div 
                  class="properties-card">
                  <div class="properties-img">
                    <router-link :to="'/ProdutoDetalhe/' + produto.itiId + '/' + formataLink(produto.itiNome)">
                      <img :src="$imgURL + produto.insInstitucionalImagens[0].itgUrlImagem" :alt="produto.itiNome" style="height: 180px;"></router-link>
                  </div>
                  <div class="wrap-wrapper">
                    <div class="properties-caption">
                      <h3 style="font-size: 18px;font-weight: 700;margin-bottom: 10px;">
                        <router-link :to="'/ProdutoDetalhe/' + produto.itiId + '/' + formataLink(produto.itiNome)">{{ produto.itiNome }}</router-link></h3>
                        <p v-html="produto.itiResumo1"></p>
                    </div>
                    <!--div class="properties-footer d-flex justify-content-between align-items-center" >
                      <div class="class-day">
                        <div class="btn"><router-link
                            :to="'/ProdutosDetalhe/' + produto.itiId + '/' + formataLink(produto.itiNome)">Ver
                            Mais</router-link></div>
                      </div>
                    </div-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- final produtos -->

</template>

<script>
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';
import axios from 'axios';

export default {
  name: 'ProdutoView',
  components: {
  },

  setup() {
    const route = useRoute();
    return {
      id: route.params.id,
      nome: route.params.nome
    };
  },

  data: () => ({
    bannerTopo: [],
    ListaProdutosTodos: [],
    ListaProdutosSegmento: [],
    segmentospais: [],
    NomeCategoria: "",
    tituloCategorias: "",
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    filtraProdutos(id) {
      this.ListaProdutosSegmento = this.ListaProdutosTodos.filter(x =>
        x.insInstitucionalSegmentos.some(w => w.insSegmentos.sgiId == id)
      );
      this.tituloCategorias = this.ListaProdutosSegmento[0].insInstitucionalSegmentos[0].insSegmentos.sgiNomeSegmento;
      console.log('ListaProdutosSegmento')
      console.log(this.ListaProdutosSegmento)
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Igor Paper - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Igor Paper" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  async created() {

    try {
      // Banner
      const bannerRes = await axios.get('/Process/InsInstitucional/institucional/38/topoprodutos/0/x');
      this.bannerTopo = bannerRes.data;
      
      // Menu lateral
      const segmentosRes = await axios.get('/Process/InsSegmentos/GetAll');
      this.segmentospais = segmentosRes.data
        .filter(x => x.sgiIdPai == 0 && x.sgiVisivel)
        .sort((a, b) => a.sgiNomeSegmento.localeCompare(b.sgiNomeSegmento));
      this.NomeCategoria = this.segmentospais[0]?.sgiNomeSegmento || "";

      // Produtos
      const produtosRes = await axios.get('/Process/InsInstitucional/institucional/39/listaprodutos/0/x');
      this.ListaProdutosTodos = produtosRes.data.filter(x => x.itiVisivel);
      
      this.ListaProdutosSegmento = this.ListaProdutosTodos.filter(x =>
        x.insInstitucionalSegmentos.some(w => w.insSegmentos.sgiId == this.segmentospais[0]?.sgiId)
      );
      this.tituloCategorias = this.ListaProdutosSegmento[0].insInstitucionalSegmentos[0].insSegmentos.sgiNomeSegmento;
      this.carregaMetas(this.removerTagsHTML(this.ListaProdutosSegmento[0].itiReferencia), this.ListaProdutosSegmento[0].itiNome);
      // Se veio ID na rota, aplica filtro
      if (this.id) this.filtraProdutos(this.id);
    } catch (error) {
      console.error(error);
    }
  },
}
</script>

<style scoped>
.produtos-wrapper {
  display: flex;
  gap: 20px;
  padding-top: 0px;
  padding-bottom: 60px;
  padding-left: 60px;
  padding-right: 60px;
}

/* Menu lateral */
.menu-lateral {
  width: 220px;
  flex-shrink: 0;
}

.menu-lateral .menu-toggle {
  display: none;
  background: #1696e7;
  color: #fff;
  padding: 10px;
  cursor: pointer;
  border-radius: 6px;
  text-align: center;
}

.menu-lateral ul {
  list-style: none;
  padding: 0;
}

.menu-lateral li {
  margin-bottom: 10px;

}

.menu-lateral a {
  display: block;
  padding: 10px;
  text-decoration: none;
  background: #f4f4f4;
  border-radius: 6px;
  color: #333;
  transition: background 0.3s;
}

.menu-lateral a:hover,
.menu-lateral a.active {

  color: #c6a84d;
}

/* Lista de produtos */
.grade-produtos {
  flex: 1;
}

.linha {
  display: grid;
  grid-template-columns: 150px 1fr 2fr 150px;
  align-items: center;
  padding: 15px;
  gap: 15px;
}

.linha-branca {
  background-color: #fff;
}

.linha-cinza {
  background-color: #f5f6f7;
}

.col-imagem {
  max-width: 150px;
  height: auto;
  border: 1px solid #ccc;
}

.col-titulo p {
  font-weight: bold;
}

.col-descricao p {
  color: #333;
}

.col-botoes {
  display: flex;
  gap: 10px;
}

/* Responsivo */
@media (max-width: 992px) {
  .produtos-wrapper {
    flex-direction: column;
  }

  .menu-lateral {
    width: 100%;
  }

  .menu-lateral .menu-toggle {
    display: block;
    margin-bottom: 10px;
  }

  .menu-lateral ul {
    display: none;
    flex-direction: column;
    gap: 10px;
  }

  .menu-lateral ul.aberto {
    display: flex;
  }

  .linha {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .col-botoes {
    justify-content: center;
  }
}


.top-banner-area {
  width: 100%;
  overflow: hidden;
}

.top-banner-content {
  position: relative;
  width: 100%;
  height: clamp(180px, 26vw, 420px);
  background: #000;
}

.top-banner-image {
  width: 100%;
  height: 100%;
  /*object-fit: contain; /* mostra a imagem inteira */
  object-position: center;
  display: block;
}

.top-banner-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
}

.top-banner-overlay .container,
.top-banner-overlay .row {
  height: 100%;
}

.hero-caption2 {
  color: #fff;
}

.hero-caption2 h2 {
  margin: 0;
  color: #fff;
}

/* notebook 1366 */
@media (min-width: 1200px) and (max-width: 1366px) {
  .top-banner-content {
    height: 300px;
  }
}

/* tablet */
@media (max-width: 991px) {
  .top-banner-content {
    height: 240px;
  }
}

/* mobile */
@media (max-width: 767px) {
  .top-banner-content {
    height: 160px;
  }

  .top-banner-image {
    object-fit: cover;
  }

  .hero-caption2 h2 {
    font-size: 22px;
  }
}



</style>